<a *ngIf="items && items[0]" class="icon-container" (click)="onIconClicked(items[0])" id="{{items[0].id}}">
    <sc-icon [icon]="icon" size="1"></sc-icon>
</a>
<span class="tooltip-container" *ngIf="tooltip">
    {{tooltip}}
</span>
